import { useComposableApi } from '@composable-api/config'
import type { LocaleLanguage } from '@sim-api-enums/i18n'
import { mapLocaleToIso1Code } from '@sim-api-utils/localization'

export default defineNuxtPlugin({
    name: 'setup',
    parallel: true,
    dependsOn: ['properties'],
    setup: () => {
        const api = useComposableApi()

        const nuxtApp = useNuxtApp()

        const { currency, countryModel } = useProperties()

        // TODO: make values reactive
        // TODO: fix usage in '/simploshop-fe/shared/modules/simploshop-api/src/runtime/composables/localization.ts'
        api.setHeader('Language-Preference', nuxtApp.$i18n.localeProperties.value.language as LocaleLanguage)
        api.setHeader('Currency-Preference', currency.value as any)

        const { formatCurrency } = useCurrencyFormatter({
            locale: () => mapLocaleToIso1Code(nuxtApp.$i18n.locale.value) || 'cs',
            country: () => countryModel.value?.alpha2 || 'CZ',
            currency: currency,
        })

        const { formatNumber } = useNumberFormatter({
            locale: () => mapLocaleToIso1Code(nuxtApp.$i18n.locale.value) || 'cs',
            country: () => countryModel.value?.alpha2 || 'CZ',
        })

        const { formatDate } = useDateFormatter({
            locale: () => mapLocaleToIso1Code(nuxtApp.$i18n.locale.value) || 'cs',
            country: () => countryModel.value?.alpha2 || 'CZ',
        })

        const $formatter = {
            currency: formatCurrency,
            number: formatNumber,
            date: formatDate,
        }

        return {
            provide: {
                formatter: $formatter,
            },
        }
    },
})
